import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgInfo({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm0-10a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm0-2a1 1 0 110-2 1 1 0 010 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgInfo
